import type { ShellMessages } from "./en-ZA";

/** Afrikaans (South Africa). Typed against the English set: a missing key is a build error. */
const af: ShellMessages = {
  common: {
    loading: "Laai",
    signIn: "Meld aan",
    signOut: "Meld af",
    tryAgain: "Probeer weer",
    back: "Terug",
  },
  theme: {
    toLight: "Skakel oor na die ligte tema",
    toDark: "Skakel oor na die donker tema",
    light: "Lig",
    dark: "Donker",
  },
  locale: {
    label: "Taal",
  },
  nav: {
    toggle: "Wissel navigasie",
    collapse: "Vou die sybalk in",
    expand: "Vou die sybalk uit",
    home: "Tuis",
    allProductions: "Alle produksies",
    allModules: "Alle modules",
    thisProduction: "Hierdie produksie",
    production: "Produksie",
    chooseProduction: "Wissel produksie",
    loadingProduction: "Laai wat op hierdie produksie vir jou oop is",
    nothingOpen: "Niks op hierdie produksie is vir jou oop nie.",
  },
  /** Die organisasie-wisselaar (D37, D41, D42) — sien die Engelse lêer vir waarom die woorde Metaship s'n is. */
  organisation: {
    change: "Verander organisasie",
    pick: "Tree op vir",
    search: "Soek organisasies",
    noMatch: "Niks met daardie naam nie",
    none: "Geen organisasie",
    noneHint: "Vra 'n administrateur om jou by een te voeg",
    noneTitle: "Jy behoort tans aan geen oop maatskappy nie",
    /** D164 — a represented person in no company: her agencies, not an admin prompt. */
    representedHeading: "My werk",
    representedBy: "Verteenwoordig deur {agencies}",
    relationship: {
      principal: "Prinsipaal",
      employee: "Werknemer",
      contractor: "Kontrakteur",
      agent: "Agent",
      booker: "Bespreker",
    },
    standing: {
      blocked: "Nie beskikbaar nie",
      SUSPENDED: "Opgeskort",
      BANNED: "Deur Pinksy gesluit",
      CLOSED: "Gesluit",
    },
  },
  /** Die onderste stroop (D28, D42) — sien die Engelse lêer. */
  rail: {
    terms: "Terme en Voorwaardes",
    releaseTitle: "Die weergawe van Pinksy wat jy gebruik",
    newVersion: "Nuwe weergawe",
    newVersionTitle: "'n Nuwer weergawe is gereed — herlaai wanneer dit jou pas",
    help: "Hulp",
  },
  preauth: {
    helpAndLegal: "Hulp en regsinligting",
    support: "Hulp nodig?",
    terms: "Bepalings",
    privacy: "Privaatheid",
    poweredBy: "Aangedryf deur {vendor}",
    landingTitle: "{app} — bestemmingsblad",
    signingIn: "Meld aan…",
  },
  login: {
    email: "E-posadres",
    password: "Wagwoord",
    errorGeneric: "Aanmelding is nie voltooi nie. Probeer asseblief weer.",
    forgot: "Wagwoord vergeet?",
    passkey: "Meld aan met n sleutel",
    google: "Gaan voort met Google",
    passkeyHint: "Gebruik u vingerafdruk, gesig of toestel-PIN.",
    passkeyFailed: "Daardie sleutel is nie aanvaar nie. U kan eerder met u wagwoord aanmeld.",
    resetOffer: "Wil u he ons moet n herstelskakel na {email} stuur?",
    resetSend: "Stuur n herstelskakel",
    resetNeedEmail: "Tik u e-posadres hierbo in en vra dan vir n herstelskakel.",
    resetSent: "As daardie adres n rekening het, is n herstelskakel op pad. Dit verval oor n uur.",
    resetFailed: "Kon nie die bediener bereik nie. Probeer asseblief weer.",
  },
  security: {
    title: "Hoe u aanmeld",
    lede: "U kan met n wagwoord, n sleutel of n gekoppelde Google-rekening aanmeld. Hou ten minste een, en u kan enige van die ander verwyder.",
    passwordTitle: "Wagwoord",
    passwordOn: "n Wagwoord is gestel.",
    passwordOff: "Geen wagwoord is gestel nie.",
    passkeysTitle: "Sleutels",
    googleTitle: "Google",
    googleUnnamed: "Google-rekening",
    usePicture: "Gebruik hierdie prent",
    pictureAdded: "By u fotos gevoeg. Kies dit as u avatar op u profiel.",
    googleConnected: "Gekoppel. U kan met hierdie Google-rekening aanmeld.",
    googleNone: "Nie gekoppel nie.",
    googleHint: "Koppel enige Google-rekening, ook een waarvan die adres van u Pinksy-adres verskil. Na koppeling bring aanmelding daarmee u hierheen.",
    connectGoogle: "Koppel n Google-rekening",
    remove: "Verwyder",
    lastMethod: "Dit is die enigste manier waarop u kan aanmeld. Voeg eers n ander by.",
    removed: "Verwyder.",
    loadFailed: "Kon nie u aanmeldmetodes lees nie. Probeer asseblief weer.",
    empty: "U het nog geen sleutels nie. Voeg een by om sonder u wagwoord aan te meld.",
    unnamed: "Sleutel",
    add: "Voeg n sleutel by",
    added: "Daardie sleutel is gereed om te gebruik.",
    unsupported: "Hierdie blaaier kan nie sleutels gebruik nie. U kan steeds met u wagwoord aanmeld.",
  },
  reset: {
    title: "Kies n nuwe wagwoord",
    intro: "Stel n nuwe wagwoord vir u Pinksy-rekening.",
    newPassword: "Nuwe wagwoord",
    confirmPassword: "Bevestig nuwe wagwoord",
    mismatch: "Daardie twee wagwoorde stem nie ooreen nie.",
    submit: "Stel wagwoord",
    done: "U wagwoord is gestel.",
    doneHint: "Elke ander sessie is afgemeld. U kan nou aanmeld.",
    toSignIn: "Gaan na aanmelding",
    invalid: "Hierdie herstelskakel is nie meer geldig nie. Vra vir n nuwe een op die aanmeldskerm.",
  },
  invitation: {
    title: "Jy is genooi na {org}",
    titleBare: "Jy is genooi",
    loading: "Maak jou uitnodiging oop…",
    invalid: "Hierdie uitnodiging is nie meer geldig nie. Vra die persoon wat jou genooi het om n nuwe een te stuur.",
    chooseIntro: "Kies n wagwoord vir {email} om te aanvaar en te begin.",
    newPassword: "Kies n wagwoord",
    confirmPassword: "Bevestig wagwoord",
    mismatch: "Daardie twee wagwoorde stem nie ooreen nie.",
    claim: "Aanvaar en stel wagwoord",
    claimed: "Jy is in.",
    claimedHint: "Jou wagwoord is gestel en jy is nou deel van {org}. Meld aan om te begin.",
    signInIntro: "Jy het reeds n Pinksy-rekening as {email}. Meld aan as jouself om te aanvaar.",
    signIn: "Meld aan om te aanvaar",
    accepting: "Aanvaar jou uitnodiging…",
    accepted: "Welkom by {org}.",
    acceptedHint: "Die uitnodiging is aanvaar. Jy kan voortgaan.",
    carryOn: "Gaan voort",
    toSignIn: "Gaan na aanmelding",
    onboardingTitle: "Voltooi jou besonderhede vir die produksie",
    onboardingChooseIntro: "Kies n wagwoord vir {email}. Meld dan aan en voltooi die besonderhede wat die produksie gevra het — omtrent tien minute op jou foon.",
    onboardingSignInIntro: "Jy het reeds n Pinksy-rekening as {email}. Meld aan en jou besonderhede wag vir jou.",
    onboardingClaimedHint: "Jou wagwoord is gestel. Meld aan om jou besonderhede te voltooi.",
    onboardingSignIn: "Meld aan",
    onboardingOpen: "Maak my besonderhede oop",
    onboardingReady: "Jou besonderhede wag op jou profiel.",
  },
  onboardStart: {
    title: "Jou aansluiting by {production}",
    titleBare: "Begin jou aansluiting",
    loading: "Maak die skakel oop…",
    intro: "Die produksie het gevra dat jy jou besonderhede op Pinksy voltooi. Ons e-pos jou jou eie skakel — na {email}.",
    send: "E-pos my my aansluitingskakel",
    sent: "Gestuur. Kyk in jou e-pos by {email} — die skakel is in ’n boodskap van Pinksy. Dit kan ’n minuut neem, en kan in gemorspos beland.",
    mailOff: "E-pos is nog nie aangeskakel nie — vra die produksiekantoor.",
    throttled: "Ons het jou ’n oomblik gelede ge-e-pos — kyk in jou inkassie en gemorspos. Jy kan oor ’n paar minute weer vra.",
    notDelivered: "Die e-pos kon nie nou gestuur word nie. Probeer later weer, of vra die produksiekantoor.",
    unavailable: "Hierdie skakel kan nie nou jou aansluiting stuur nie. Vra die produksiekantoor.",
    invalid: "Hierdie skakel is nie meer geldig nie. Vra die produksiekantoor vir ’n nuwe een.",
    invalidHint: "Aansluitingskakels werk vir ’n paar weke. Die produksiekantoor kan vir jou ’n nuwe een stuur.",
    unreachable: "Pinksy kon nie nou bereik word nie. Kyk na jou sein en probeer weer.",
    unreachableHint: "Jou skakel is waarskynlik in orde — dit is gewoonlik ’n swak sein of ’n besige oomblik.",
    retry: "Probeer weer",
    signIn: "Ek het reeds ’n Pinksy-rekening — meld aan",
    footnote: "Hierdie bladsy wys nooit jou besonderhede nie. Die e-pos gaan net na die adres wat die produksie vir jou het.",
  },
  noAccess: {
    title: "Geen toegang tot {app} nie",
    text: "Jy is aangemeld, maar hierdie rekening is nie deel van hierdie toepassing nie. Vra ’n administrateur om jou by te voeg.",
    signedInAs: "Aangemeld as",
    switchAccount: "Meld aan met ’n ander rekening",
    contactSupport: "Kontak ondersteuning",
  },
  appHome: {
    greeting: "Welkom terug, {name}",
    empty: "Daar is nog geen toepassings beskikbaar nie.",
    emptyHint: "’n Administrateur kan modules by {app} voeg.",
  },
  footer: {
    language: "Taal",
    appearance: "Voorkoms",
    organisation: "Organisasie",
    signedIn: "Aangemeld",
    myProfile: "My profiel",
    installApp: "Installeer toepassing",
    greetingNight: "Brand die middernagolie",
    greetingMorning: "Goeiemôre",
    greetingAfternoon: "Goeiemiddag",
    greetingEvening: "Goeienaand",
    greetingLate: "Werk laat",
  },
};

export default af;
